"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getBallsRemaining_1 = __importDefault(require("./getBallsRemaining"));
const getRunRateRequired = (props) => {
    if (!props.ballsPerOver)
        props.ballsPerOver = 6;
    return Number(Number(props.runsRequired /
        (getBallsRemaining_1.default({
            ballsPerOver: props.ballsPerOver,
            oversBowled: props.oversBowled,
            oversPerInnings: props.oversPerInnings,
            oversTarget: props.oversTarget,
        }) /
            props.ballsPerOver)).toFixed(2));
};
exports.default = getRunRateRequired;
//# sourceMappingURL=getRunRateRequired.js.map